module.exports = __webpack_public_path__ + "assets/img/8_1679_big.f9c90f76.jpg";